type Preference = {
    domain: string;
    code: string;
    description: string;
    charValue: string | null;
    numberValue: string;
};

const getPreference = (
    preferences: Preference[],
    domain: string,
    code: string
): string | undefined => {
    const preference = preferences.find(
        (p) => p.domain === domain && p.code === code
    );
    return preference?.numberValue;
};

export { getPreference };
